<template>
  <ul id="list-tasks">
    <li>
      <!-- pc view -->
      <div class="oblea" v-if='!mobileView' @click="clickOblea">
        <div class="fh lc" style="width: 100%; height: 32%;  margin-left: 10px; margin-right: 10px">
          <span style="width:140px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; font-size: 15px; font-weight: 500;color: #5c666f">
             {{item.Nombre}}
          </span>
          </div>  
            <div class="fh cc" style="width: 100%; height: 65%; margin-left: 10px; margin-right: 10px; margin-bottom: 10px">
            <div class="fh lc" style="width: 50%; height: 100%;">
              <!-- <img style="width: 75%; margin: 2px" :src="imagenProducto" />  -->
              <img style="width: 95%; height: 95%; object-fit: contain;" :src="imagenProducto" /> 
            </div>
            <div class="fv lc" style="width: 50%; height: 100%;">
              <p style="font-size: 10px ;font-weight: 400;color: #5c666f">Precio normal:</p>
              <p style="font-size: 10px ;font-weight: 400;color: #5c666f">${{item.PrecioHabitual | formatMoney}}</p>
              <p style="font-size: 11px ;font-weight: 500; margin-top: 10px;color: #5c666f">Promoción:</p>
              <p style="font-size: 11px ;font-weight: 500;color: #5c666f">${{item.PrecioPromocional | formatMoney}}</p>
          </div>
         </div>
      </div>
      <!-- mobile view -->
      <div class="oblea" style="width: 140px; height: 90px; padding: 5px 5px 5px 5px;" @click="clickOblea" v-if='mobileView'>
        <div class="fh lc" style="width: 100%; height: 35%;  margin-left: 5px; margin-right: 5px">
          <span style="width:140px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; font-size: 15px; font-weight: 500;color: #5c666f">
            {{item.Nombre}}
          </span>
        </div>  
        <div class="fh cc" style="width: 100%; height: 65%; margin-left: 5px; margin-right: 5px; margin-bottom: 5px">
          <div class="fh lc" style="width: 50%; height: 100%;">
            <img style="width: 90%; margin: 2px" :src="imagenProducto" /> 
          </div>
          <div class="fv lc" style="width: 50%; height: 100%;">
            <p style="font-size: 9px ;font-weight: 400;color: #5c666f">Precio normal:</p>
            <p style="font-size: 10px ;font-weight: 400;color: #5c666f">${{item.PrecioHabitual | formatMoney}}</p>
            <p style="font-size: 9px ;font-weight: 500; margin-top: 10px;color: #5c666f">Promoción:</p>
            <p style="font-size: 10px ;font-weight: 500;color: #5c666f">${{item.PrecioPromocional | formatMoney}}</p>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>



 
<script>
  import axios from 'axios'

  export default {
    name: 'item-promocionesHome',
    props: ['item'],

    data() {
      return {
        mobileView:false  
      }
    },  

    watch: {
      item: {
        immediate: true,
        handler  () {
        }
      }
    },

    computed: {
        imagenProducto() {
          if (this.item.ImagenesUrl.length > 0) {
            return this.item.ImagenesUrl[0]
          }
          else {
            return '/dist/placeholder-producto.png'
          }
        } 
    },


   methods: {

      onResize() {
        if (window.innerWidth > 600) 
        {
           this.mobileView=false;
        }
        else 
        {
           this.mobileView=true;
        }
      },

      clickOblea () {
        this.$router.push({ name: 'promociones' });
      },
    
     },

    mounted() {
      this.onResize()
    },

    created() {
     window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
    }

  }
</script>


<style scoped>

  * {
   margin:  0;
   padding: 0;
  }
        
  li {
   float: left;
   display: block;
   padding-right: 20px;
   text-decoration: none;
  }
        
  .oblea{
    width: 190px;
    height: 120px;
    border-width: 1px;
    border: 1px solid #dddddd;
    background: #ffffff;
    box-shadow: 2px 2px 4px #dddddd;  
    -webkit-box-shadow: 2px 2px 4px #dddddd;  
    -moz-box-shadow:    2px 2px 4px #dddddd;  
   }

.oblea:hover{
    cursor: pointer;
  }      

#container{
  display: flex;      
  flex-direction:row; 
  align-items: flex-start;  
}

#titulo-container{
   width: 180px;
   height: 25px;
   background: #ffffff;
   display: flex;      
   justify-content: center;  
   align-items: center;  
}


#titulo{
  width:140px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  font-size: 15px; 
  font-weight: 500;
}

#imagen-container{
  width: 70px;
  height: 80px;
  background-color: #ffffff; 
  display: flex;      
  justify-content: center;  
  align-items: flex-end;  
}


#imagenProducto{
  max-width: 100%;
  max-height: 100%;
}


#texto{
    width: 120px;
    height: 30px;
    margin-left: 10px;
    margin-top: 20px;
}
        
        
</style>


// WEBPACK FOOTER //
// src/components/views/home/itemPromocionHome.vue